var _rect, _rect2, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPlaceholder1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    role: "img",
    "aria-label": "\\uC124\\uCE58 \\uC0AC\\uC9C4 \\uC900\\uBE44\\uC911 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 360,
    fill: "#eef1f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 452,
    height: 332,
    rx: 10,
    fill: "none",
    stroke: "#c4ccce",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 150,
    textAnchor: "middle",
    fontFamily: "'Noto Sans KR','Malgun Gothic',sans-serif",
    fontSize: 88,
    fontWeight: 800,
    fill: "#c4ccce"
  }, "1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 220,
    textAnchor: "middle",
    fontFamily: "'Noto Sans KR','Malgun Gothic',sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#7d8a8c"
  }, "\uC124\uCE58 \uC0AC\uC9C4 \uC900\uBE44\uC911")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholder1);
export default __webpack_public_path__ + "static/media/location_placeholder_1.be56562613f810b3554f3c7789299112.svg";
export { ForwardRef as ReactComponent };